exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".disclaimer-wrapper .home-heading {\n\tpadding: 20px;\n}\n\n.disclaimer-wrapper .disclaimer-body {\n\tpadding: 0 10px 10px;\n}\n\n.disclaimer-wrapper .next-back-btn-wrap {\n\tfont-size: 17px;\n\tdisplay: -webkit-box;\n\tdisplay: -ms-flexbox;\n\tdisplay: flex;\n\t-webkit-box-orient: horizontal;\n\t-webkit-box-direction: normal;\n\t    -ms-flex-flow: row;\n\t        flex-flow: row;\n\tborder-top: 1px solid #ccc;\n\tpadding: 10px 0;\n}\n\n.disclaimer-wrapper .next-back-btn-wrap .btn-cancel{\n\tcolor: #ccc;\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/rubylover/Work/new_vin_photo/site/web/src/app/modals/disclaimer-modal/disclaimer-modal.component.css
// module id = ../../../../../src/app/modals/disclaimer-modal/disclaimer-modal.component.css
// module chunks = main